var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDragDotsIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "drag-handle-line",
    transform: "translate(-13.5 -10.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M15.833,11.667A1.167,1.167,0,1,1,14.667,10.5,1.167,1.167,0,0,1,15.833,11.667Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M15.833,23.667A1.167,1.167,0,1,1,14.667,22.5,1.167,1.167,0,0,1,15.833,23.667Z",
    transform: "translate(0 -2.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M21.833,11.667A1.167,1.167,0,1,1,20.667,10.5,1.167,1.167,0,0,1,21.833,11.667Z",
    transform: "translate(-1.333 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M21.833,23.667A1.167,1.167,0,1,1,20.667,22.5,1.167,1.167,0,0,1,21.833,23.667Z",
    transform: "translate(-1.333 -2.334)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M21.833,17.667A1.167,1.167,0,1,1,20.667,16.5,1.167,1.167,0,0,1,21.833,17.667Z",
    transform: "translate(-1.333 -1.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M15.833,17.667A1.167,1.167,0,1,1,14.667,16.5,1.167,1.167,0,0,1,15.833,17.667Z",
    transform: "translate(0 -1.167)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragDotsIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/drag_dots_icon.2fca48a8234cb0bb936276ce00fcb652.svg";